"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newPackagesReducer = exports.initialState = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* Package Imports */
var connected_react_router_1 = require("connected-react-router");
var immutable_1 = require("immutable");
var moment_1 = __importDefault(require("moment"));
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var actions = __importStar(require("./actions"));
var models_1 = require("@app/_state/models");
var utils_1 = require("@app/_state/utils");
var transfersActions = __importStar(require("@app/features/transfers/state/actions"));
var constants_1 = require("@server/shared/constants");
var api_1 = require("@server/types/api");
exports.initialState = {
    containsArchivedPackages: false,
    containsHeldPackages: false,
    isResetting: false,
    isSearching: false,
    packages: [],
    savedWorkgroupEmail: '',
    selectedUsers: [],
    sortDirection: -1,
    sortKey: constants_1.creationDateSortField,
    totalCount: -1,
    totalSearchCount: -1,
    viewingWorkgroup: false
};
/* Utility reducer functions - begin */
/*
const combinePackages = (packageList1: PackageModel[], packageList2: PackageModel[]): PackageModel[] => {
  const combinedList: PackageModel[] = [];
  const packageOrderedMap1: OrderedMap<string, PackageModel> = mapPackagesToOrderedMap(packageList1);
  const packageOrderedMap2: OrderedMap<string, PackageModel> = mapPackagesToOrderedMap(packageList2);
  
  const existingPackagesList1: number[] = [];
  const existingPackagesList2: number[] = [];
  
  for (const p of packageList1) {
    if (packageOrderedMap2.has(p.id)) {
      existingPackagesList1.push(1);
    } else {
      existingPackagesList1.push(0);
    }
  }
  // tslint:disable:no-console
  console.log(`EXISTING LIST 1`);
  console.log(existingPackagesList1);

  for (const p of packageList2) {
    if (packageOrderedMap1.has(p.id)) {
      existingPackagesList2.push(1);
    } else {
      existingPackagesList2.push(0);
    }
  }
  // tslint:disable:no-console
  console.log(`EXISTING LIST 2`);
  console.log(existingPackagesList2);
  
  let list1Tracker: number = 0;
  let list2Tracker: number = 0;
  // const maxListSize: number = (packageList2.length >= packageList1.length) ? packageList2.length : packageList1.length;
  // for (let i = 0; i < (packageList1.length + packageList2.length); i++) {
  while (list1Tracker < packageList1.length && list2Tracker < packageList2.length) {
    // tslint:disable:no-console
    console.log(`LOOP list1Tracker=${list1Tracker}, list2Tracker=${list2Tracker}`);
    if (list1Tracker < packageList1.length) {
      console.log(`ExistingList1=${existingPackagesList1[list1Tracker]}, PackageList1 Id=${packageList1[list1Tracker].id}`);
    }
    if (list2Tracker < packageList2.length) {
      console.log(`ExistingList2=${existingPackagesList2[list2Tracker]}, PackageList2 Id=${packageList2[list2Tracker].id}`);
    }
    if (list1Tracker < packageList1.length && list2Tracker < packageList2.length) {
      if (existingPackagesList2[list2Tracker] === 0) {
        combinedList.push(packageOrderedMap2.get(packageList2[list2Tracker].id)!);
        list2Tracker++;
      } else if (existingPackagesList2[list2Tracker] === existingPackagesList1[list1Tracker]) {
        combinedList.push(mergePackageModels(packageOrderedMap2.get(packageList2[list2Tracker].id)!, packageOrderedMap1.get(packageList1[list1Tracker].id)!));
        list1Tracker++;
        list2Tracker++;
      } else if (existingPackagesList1[list1Tracker] === 0) {
        combinedList.push(packageOrderedMap1.get(packageList1[list1Tracker].id)!);
        list1Tracker++;
      }
    } else if (list2Tracker < packageList1.length) {
      if (existingPackagesList2[list2Tracker] === 0) {
        combinedList.push(packageOrderedMap2.get(packageList2[list2Tracker].id)!);
        list2Tracker++;
      }
    } else if (list1Tracker < packageList2.length) {
      if (existingPackagesList1[list1Tracker] === 0) {
        combinedList.push(packageOrderedMap1.get(packageList1[list1Tracker].id)!);
        list1Tracker++;
      }
    }
  }
  
  return combinedList;
};
*/
var mapPackagesToOrderedMap = function (packages) {
    var orderedMap = immutable_1.OrderedMap();
    packages.forEach(function (p) {
        orderedMap = orderedMap.set(p.id, p);
    });
    return orderedMap;
};
var mergePackageLists = function (packageList1, packageList2, sortKey, sortDirection) {
    var newPackagesOrderedMap = mapPackagesToOrderedMap(packageList2);
    for (var _i = 0, packageList1_1 = packageList1; _i < packageList1_1.length; _i++) {
        var p = packageList1_1[_i];
        if (newPackagesOrderedMap.has(p.id)) {
            newPackagesOrderedMap = newPackagesOrderedMap.set(p.id, utils_1.mergePackageModels(newPackagesOrderedMap.get(p.id), p));
        }
        else {
            newPackagesOrderedMap = newPackagesOrderedMap.set(p.id, p);
        }
    }
    newPackagesOrderedMap = sortPackages(newPackagesOrderedMap, sortKey, sortDirection);
    return newPackagesOrderedMap.valueSeq().toArray();
};
var sortPackages = function (packages, sortKey, sortDirection) {
    if (sortKey === constants_1.creationDateSortField) {
        if (sortDirection > 0) {
            packages = packages.sort(function (a, b) { return a.creationDate && b.creationDate ? moment_1.default(a.creationDate).diff(b.creationDate) : 0; });
        }
        else {
            packages = packages.sort(function (a, b) { return a.creationDate && b.creationDate ? moment_1.default(b.creationDate).diff(a.creationDate) : 0; });
        }
        return packages;
    }
    else if (sortKey === constants_1.expirationDateSortField) {
        if (sortDirection > 0) {
            packages = packages.sort(function (a, b) { return a.expirationDate && b.expirationDate ? moment_1.default(a.expirationDate).diff(b.expirationDate) : 0; });
        }
        else {
            packages = packages.sort(function (a, b) { return a.expirationDate && b.expirationDate ? moment_1.default(b.expirationDate).diff(a.expirationDate) : 0; });
        }
        return packages;
    }
    else if (sortKey === constants_1.senderNameSortField) {
        if (sortDirection > 0) {
            packages = packages.sort(function (a, b) { return (a.sender && b.sender) ? (a.sender.lastName + ", " + a.sender.firstName).localeCompare(b.sender.lastName + ", " + b.sender.firstName) : 0; });
        }
        else {
            packages = packages.sort(function (a, b) { return (a.sender && b.sender) ? (b.sender.lastName + ", " + b.sender.firstName).localeCompare(a.sender.lastName + ", " + a.sender.firstName) : 0; });
        }
        return packages;
    }
    else if (sortKey === constants_1.sizeSortField) {
        if (sortDirection > 0) {
            packages = packages.sort((function (a, b) { return (a.totalBytes && b.totalBytes) ? a.totalBytes - b.totalBytes : 0; }));
        }
        else {
            packages = packages.sort((function (a, b) { return (a.totalBytes && b.totalBytes) ? b.totalBytes - a.totalBytes : 0; }));
        }
        return packages;
    }
    else if (sortKey === constants_1.titleSortField) {
        if (sortDirection > 0) {
            packages = packages.sort(function (a, b) { return (a.title && b.title) ? ("" + a.title).localeCompare("" + b.title) : 0; });
        }
        else {
            packages = packages.sort(function (a, b) { return (a.title && b.title) ? ("" + b.title).localeCompare("" + a.title) : 0; });
        }
        return packages;
    }
    else {
        return packages;
    }
};
/* Utility reducer functions - end */
var newPackagesReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        // New Packages actions
        case typesafe_actions_1.getType(actions.cancelDismissNewPackage): {
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) {
                    if (p.id === action.payload) {
                        return __assign(__assign({}, p), { dismissBannerVisible: false });
                    }
                    return p;
                }) });
        }
        case typesafe_actions_1.getType(actions.dismissNewPackage): {
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) {
                    if (p.title.toLowerCase() === action.payload.title.toLowerCase() && moment_1.default(p.creationDate).isSame(action.payload.creationDate)) {
                        return __assign(__assign({}, p), { dismissBannerVisible: true });
                    }
                    return p;
                }) });
        }
        case typesafe_actions_1.getType(actions.getNewPackagesSuccess): {
            var hideArchivedPkgs_1 = action.payload.hideArchivedPkgs;
            var statePackages = state.packages;
            var mappedNewPackages = utils_1.mapPackagesToModel(action.payload.packages);
            var mappedPackages = [];
            if (action.payload.mergeWithExisting && state.packages.length !== 0) {
                mappedPackages = mergePackageLists(statePackages, mappedNewPackages, state.sortKey, state.sortDirection);
            }
            else {
                mappedPackages = mappedNewPackages;
            }
            mappedPackages.filter(function (p) {
                if (hideArchivedPkgs_1) {
                    return !p.archived;
                }
                else {
                    return true;
                }
            });
            var newPackages = action.payload.appendRows ? __spreadArray(__spreadArray([], state.packages), mappedPackages) :
                mappedPackages;
            return __assign(__assign({}, state), { packages: newPackages, viewingWorkgroup: action.payload.viewingWorkgroup });
        }
        case typesafe_actions_1.getType(actions.markPackageAsArchived):
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) { return p.id === action.payload ? __assign(__assign({}, p), { archived: true }) : p; }) });
        case typesafe_actions_1.getType(actions.removeReadPackage): {
            var unloadedPackages = state.totalCount - state.packages.length;
            var newPackages = state.packages.filter(function (p) { return p.id !== action.payload; });
            var archivedPackages = newPackages.filter(function (p) { return p.archived; });
            return __assign(__assign({}, state), { containsArchivedPackages: (archivedPackages.length > 0), totalCount: ((newPackages.length + unloadedPackages) - archivedPackages.length), packages: newPackages });
        }
        case typesafe_actions_1.getType(actions.removeReadPackages): {
            var newPackages = state.packages.filter(function (p) {
                var found = true;
                action.payload.forEach(function (id) {
                    if (id === p.id) {
                        found = false;
                    }
                });
                return found;
            });
            return __assign(__assign({}, state), { packages: newPackages, totalCount: state.totalCount - action.payload.length, totalSearchCount: newPackages.length });
        }
        case typesafe_actions_1.getType(actions.resetSort):
            return __assign(__assign({}, state), { sortKey: exports.initialState.sortKey, sortDirection: exports.initialState.sortDirection });
        case typesafe_actions_1.getType(actions.resettingNewPackages):
            return __assign(__assign({}, state), { isResetting: action.payload });
        case typesafe_actions_1.getType(actions.saveWorkgroupEmail):
            return __assign(__assign({}, state), { savedWorkgroupEmail: action.payload });
        case typesafe_actions_1.getType(actions.setIncludeHeldNewPackages):
            return __assign(__assign({}, state), { containsHeldPackages: action.payload });
        case typesafe_actions_1.getType(actions.setIsSearching):
            return __assign(__assign({}, state), { isSearching: action.payload });
        case typesafe_actions_1.getType(actions.setPackageTransferStatus): {
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) { return p.id === action.payload.packageId ? __assign(__assign({}, p), { transferStatus: action.payload.transferStatus }) : p; }) });
        }
        case typesafe_actions_1.getType(actions.setPackageUpdating): {
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) { return p.id === action.payload.packageId ? __assign(__assign({}, p), { isUpdating: action.payload.isUpdating }) : p; }) });
        }
        case typesafe_actions_1.getType(actions.updateSort):
            return __assign(__assign({}, state), { sortKey: action.payload.sortKey, sortDirection: action.payload.sortDirection });
        case typesafe_actions_1.getType(actions.updateTotalCount): {
            return __assign(__assign({}, state), { containsArchivedPackages: (state.packages.length === action.payload.totalCount) ? false : true, totalCount: action.payload.totalCount, totalSearchCount: action.payload.updateSearchTotal ? action.payload.totalCount : state.totalSearchCount });
        }
        case typesafe_actions_1.getType(actions.updateTotalSearchCount): {
            return __assign(__assign({}, state), { containsArchivedPackages: false, totalSearchCount: action.payload });
        }
        // Transfers actions
        case typesafe_actions_1.getType(transfersActions.connectDownloadRequest):
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) { return p.id !== action.payload.packageId ? p : __assign(__assign({}, p), { transferredBytes: 0, state: models_1.PackageTransferState.IN_PROGRESS, errorMsg: '' }); }) });
        case typesafe_actions_1.getType(transfersActions.connectTransferReject):
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) { return p.id !== action.payload.packageId ? p : __assign(__assign({}, p), { errorMsg: "Error downloading the package. Retry and 'Allow' connection with Aspera Connect", state: models_1.PackageTransferState.FAILED }); }) });
        case typesafe_actions_1.getType(transfersActions.downloadReject):
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) { return p.id !== action.payload.packageId ? p : __assign(__assign({}, p), { errorMsg: "Error downloading the package", state: models_1.PackageTransferState.FAILED }); }) });
        case typesafe_actions_1.getType(transfersActions.httpUploadSuccess):
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) { return p.id === action.payload.packageId ? __assign(__assign({}, p), { archived: true }) : p; }) });
        case typesafe_actions_1.getType(transfersActions.updateTransfer): {
            var updatePackages = state.packages.map(function (p) {
                return ((action.payload.packageId && action.payload.packageId === p.id) ||
                    moment_1.default(p.creationDate).isSame(action.payload.creationDate)) &&
                    (p.pkgState !== models_1.PackageState.DELETED && p.pkgState !== models_1.PackageState.EXPIRED) ? __assign(__assign({}, p), { transferredBytes: action.payload.transferredBytes, state: ((action.payload.direction === api_1.Direction.RECEIVE) && (action.payload.isFullPackage)) ? action.payload.state : undefined, packageTransferId: (((action.payload.direction === api_1.Direction.RECEIVE) && (action.payload.isFullPackage)) && (action.payload.transferId)) ? action.payload.transferId : '', errorCode: action.payload.errorCode, errorDesc: action.payload.errorDesc, errorMsg: (action.payload.state === models_1.PackageTransferState.FAILED) ? 'Error downloading the package' : '' }) : p;
            });
            return __assign(__assign({}, state), { packages: updatePackages });
        }
        // React Router actions
        case connected_react_router_1.LOCATION_CHANGE: {
            var unloadedPackages = state.totalCount - state.packages.length;
            var nonArchivedPackages = state.packages.filter(function (p) {
                if (state.savedWorkgroupEmail === '') {
                    return !p.archived;
                }
                else {
                    return true;
                }
            });
            return __assign(__assign({}, state), { containsArchivedPackages: false, containsHeldPackages: false, packages: nonArchivedPackages, totalCount: (state.savedWorkgroupEmail === '') ? (nonArchivedPackages.length + unloadedPackages) : state.totalCount });
        }
        default:
            return state;
    }
};
exports.newPackagesReducer = newPackagesReducer;
